import http from '@/biz/http.mjs'

export default {

    create: (data) => http.post('/rmsfs', data),

    publish: (data) => http.put(
        '/rmsfs/rlsandrevise',
        {...data, stsCode: 'RLS'}
    ),

    pull: ({pkid}) => http.get(`/rmsfs/${pkid}/dps`),
    push: (data) => http.post('/rmsfs/batchmodify', data),
    read: ({pkid}) => http.get(`/rmsfs/${pkid}`),
    readList: (args) => http.get('/rmsfs', args),

    revise: ({pkid}) => http.put(
        '/rmsfs/rlsandrevise',
        {pkid, stsCode: 'REVISE'}
    ),

    update: (data) => http.put(`/rmsfs/${data.pkid}`, data),
    updateMap: (data) => http.put(`/rmsfs/${data.pkid}/map`, data),
}
